import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './styles.less';

const PepInfo = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const hideModal = () => setModalVisible(false);
  const openModal = () => setModalVisible(true);

  const modalFooter = (
    <Button type="primary" onClick={hideModal}>
      Entendido
    </Button>
  );

  return (
    <div>
      <Button className="pep-info__button" type="link" onClick={openModal}>
        <InfoCircleOutlined />{' '}
        <u className="pep-info__button__text">Sobre Personas Expuestas Políticamente</u>
      </Button>
      <Modal visible={isModalVisible} onCancel={hideModal} footer={modalFooter}>
        <p>
          <b>Persona Expuesta Políticamente - PEP</b>
        </p>
        <p>
          Persona que actualmente desempeñe o haya desempeñado uno o más de los siguientes cargos o
          ser cónyuge o pariente hasta el segundo grado de consanguinidad (abuelo(a), padre, madre,
          hijo(a), hermano(a), nieto(a), con ninguna de las Personas Políticamente Expuestas que a
          continuación de indican, sea que actualmente desempeñen o hayan desempeñado uno o más de
          los siguientes cargos:
        </p>
        <ol>
          <li>Presidente de la Repúbilca. Senadores, Diputados y Alcaldes.</li>
          <li>Ministros de la Corte Suprema y Cortes de Apelaciones.</li>
          <li>
            Ministros de Estadom, Subsecretarios, Intendentes, Gobernadores, Secretarios Regionales
            Ministeriales, Embajadores, Jefes Superiores de Servicio, tanto centralizados como
            descentralizados y el directivo superior inmediato que deba subrogar a cada uno de
            ellos.
          </li>
          <li>
            Comandantes en jefe de las Fuerzas Armadas, Director General Carabineros, Director
            General de investigaciones, y el oficial superior inmediato que deba subrogar a cada uno
            de ellos.
          </li>
          <li>Fiscal Nacional del Ministerio Público y Fiscales Regionales.</li>
          <li>Contralor General de la República.</li>
          <li>Consejeros del Banco Central de Chile.</li>
          <li>Consejeros del Consejo de Defensa del Estado.</li>
          <li>Ministros del Tribunal Constitucional.</li>
          <li>Ministros del Tribunal de la Libre Competencia.</li>
          <li>Integrantes titulares y suplentes del Tribunal de Contratación Pública.</li>
          <li>Consejeros del Consejo de Alta Dirección Pública.</li>
          <li>
            Los directores y ejecutivos principales de empresas públicas, según lo definido por la
            Ley N° 18.045.
          </li>
          <li>Directores de sociedades anónimas nombrados por el Estado o sus organismos.</li>
          <li>Miembros de las directivas de los partidos políticos.</li>
        </ol>
      </Modal>
    </div>
  );
};

export default PepInfo;
